import { v4 as uuidv4 } from 'uuid';

export function Wishlist(props = {}, childrenComponents = []) {
	return {
		componentName: 'Wishlist',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'wishlist',
				toastURL: '/wishlist',
			},
			props,
		),
		childrenComponents,
	};
}
